import { LoanStatuses } from '@app/configs/loanApplication';
export const getScheduleStatusVariant = (status) => {
    switch (status.toLowerCase()) {
        case LoanStatuses.Paid:
            return 'success';
        case LoanStatuses.Overdue:
            return 'critical';
        default:
            return null;
    }
};
